
//params 数据放到请求 params中

interface contentResObject {
  msg?: string;
  status?: number;
  data?: any;
}
export const ApiGetContent = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/content-url/rest/polaris/globalset', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiCustomprodContent = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/content-url/rest/polaris/customprod/content', params)
      .then((data: any) => {
        let res = data.data._value;
        console.log(res, 'res');
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiFaqList = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/content-url/rest/polaris/faq/tree', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
export const ApiFaqDetail = (params: object) => {
  return new Promise((resolve, reject) => {
    onRequest('get', '/content-url/rest/polaris/faq/content', params)
      .then((data: any) => {
        let res = data.data._value;
        if (res.status == 0) {
          resolve(res.data);
        }
      })
      .catch((err: object) => {
        reject(err);
      });
  });
};
